import { moveToLink } from "@socar-inc/web-frontend-libraries";

export const moveToExternal = (url: string) => {
  moveToLink(`socar-v2://open-url/external?url=${encodeURIComponent(url)}`);
};
